// pages/Dashboard.jsx
import TermsAndConditions from "../../components/home/policyComponents/TermsAndConditions";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <TermsAndConditions />
    </HomeLayout>
  );
}
